import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=45154f3e&scoped=true"
import script from "./HelpButton.vue?vue&type=script&lang=ts"
export * from "./HelpButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45154f3e",
  null
  
)

export default component.exports